





import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { AbstractItem, instanceOfIFontSizeAutoAdjustable } from "../../../domain/document/items";
import { Color } from "../../../domain/drawing";
// TODO: ここもindex.ts作成して一まとめにしたかったが上手くいかない.後で調査.
import SingleLinePropertyEditor from "./propertyEditors/SingleLinePropertyEditor.vue";
import DirectiveLinePropertyEditor from "./propertyEditors/DirectiveLinePropertyEditor.vue";
import TexturedShapePropertyEditor from "./propertyEditors/TexturedShapePropertyEditor.vue";
import TextPropertyEditor from "./propertyEditors/TextPropertyEditor.vue";
import TextBoxPropertyEditor from "./propertyEditors/TextBoxPropertyEditor.vue";
import MovableTextBoxPropertyEditor from "./propertyEditors/MovableTextBoxPropertyEditor.vue";
import ExternalDataPropertyEditor from "./propertyEditors/ExternalDataPropertyEditor.vue";
import OptionSelectableTextPropertyEditor from "./propertyEditors/OptionSelectableTextPropertyEditor.vue";
import CircleSelectPropertyEditor from "./propertyEditors/CircleSelectPropertyEditor.vue";
import CheckBoxPropertyEditor from "./propertyEditors/CheckBoxPropertyEditor.vue";
import DatePropertyEditor from "./propertyEditors/DatePropertyEditor.vue";
import ImagePropertyEditor from "./propertyEditors/ImagePropertyEditor.vue";
import MovableImagePropertyEditor from "./propertyEditors/MovableImagePropertyEditor.vue";
import JoinTextPropertyEditor from "./propertyEditors/JoinTextPropertyEditor.vue";
import RichTextBoxPropertyEditor from "./propertyEditors/RichTextBoxPropertyEditor.vue";
import NotImplementedPropertyEditor from "./propertyEditors/NotImplementedPropertyEditor.vue";
import Empty from "../../system/EmptyComponent.vue";

@Component({
  components: {
    // ここに文書オブジェクトコンポーネントを記載要.DocuCoreとして考えると標準以外の文書オブジェクトをどうサポートするか？要検討.
    // TODO: とりあえず仮実装で未実装の物はNotImplementedで.
    LineItem: DirectiveLinePropertyEditor,
    PolylineItem: SingleLinePropertyEditor,
    TextBoxItem: TextBoxPropertyEditor,
    MovableTextBoxItem: MovableTextBoxPropertyEditor,
    RichTextBoxItem: RichTextBoxPropertyEditor,
    BoxLineItem: TexturedShapePropertyEditor,
    CircleItem: TexturedShapePropertyEditor,
    TriangleItem: SingleLinePropertyEditor,
    CrossItem: SingleLinePropertyEditor,
    DateItem: DatePropertyEditor,
    CircleSelectItem: CircleSelectPropertyEditor,
    CalculateItem: TextPropertyEditor,
    ComboBoxItem: OptionSelectableTextPropertyEditor,
    ImageItem: ImagePropertyEditor,
    CheckBoxItem: CheckBoxPropertyEditor,
    NotImplementedItem: NotImplementedPropertyEditor,
    RollItem: OptionSelectableTextPropertyEditor,
    ExternalDataItem: ExternalDataPropertyEditor,
    ExternalProcessItem: Empty,
    BarcodeItem: Empty,
    PositionCorrectItem: Empty,
    MovableImageItem: MovableImagePropertyEditor,
    NewPageItem: Empty,
    GraphItem: Empty,
    RangeOfMotionItem: Empty,
    HeaderFooterTextItem: Empty,
    JoinTextItem: JoinTextPropertyEditor,
  }
})
export default class PropertyEditor extends Mixins() {
  @Prop()
  source: AbstractItem;

  @Prop()
  pallet: Color[];

  get isVisible(): boolean {
    return !!this.editingSource;
  }

  get key(): string {
    return this.editingSource.typeKey;
  }

  get editingSource(): AbstractItem {
    return this.source;
  }

  set editingSource(value: AbstractItem) {
    if (instanceOfIFontSizeAutoAdjustable(value) && value.enabledAutoAdjustFontSize) {
      // このタイミングで自動縮小を行うことによりオブジェクトが不要にはみ出すことがなくなる
      // 続紙追加ダイアログはフォントサイズ等プロパティに触れた(オブジェクトのフォーカスが外れた)タイミングで発生するため不要
      value.adjustFontSize();
    }
    this.updateSource(value);
  }

  @Emit()
  updateSource(item: AbstractItem): any {}
}
